import { DocumentNode, gql, useMutation } from '@apollo/client';

export const GENERATE_BORDEREAU_CLAIM_REPORT = gql`
  mutation Bordereau($details: BordereauClaimReportInput!) {
    generateBordereauClaimReport(details: $details) {
      result
      key
      filename
      contentType
      size
      asOfDate
      startDate
      endDate
      file
    }
  }
`;

export function useBordereauMutation() {
  const [generateReport, { loading, error, data }] = useMutation(
    GENERATE_BORDEREAU_CLAIM_REPORT as DocumentNode
  );

  return { generateReport, loading, error, data };
}
